import React, { useEffect, useState, useCallback } from 'react';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { ReactSortable } from 'react-sortablejs';

import EventItem from '../../components/EventItem';
import BirthdateItem from '../../components/BirthdateItem';
import TodoItem from '../../components/TodoItem';

import useDiaryData from '../../hooks/useDiaryData';
import useSnackbarText from '../../hooks/useSnackbarText';
import todoes from '../../api/todoes';

const dateDisplayFormat = 'DD MMM YYYY (ddd)';
const emptyList = [];

const useStyles = makeStyles(theme => ({
	root: {
		[theme.breakpoints.up('md')]: {
			paddingLeft: 30,
			paddingRight: 10,
		}
	},
	listWrapper: {
		borderTop: `1px solid #e0e0e0`,
		[theme.breakpoints.up('md')]: {
			borderLeft: `1px solid #e0e0e0`,
			borderRight: `1px solid #e0e0e0`,
		}
	},
	noFound: {
		color: '#9c9c9c',
		fontWeight: 300,
		padding: 10,
		borderBottom: `1px solid #e0e0e0`,
	},
	date: {
		position: 'sticky',
		top: theme.mixins.toolbar.minHeight,
		zIndex: 1,
		backgroundColor: 'white',
		fontWeight: 600,
		marginTop: 20,
		marginBottom: 10,
		fontSize: 20,
		[theme.breakpoints.down('sm')]: {
			display: 'none'
		}
	},
}));

function ItemListSection() {
	const classes = useStyles();
	const [diary, _, __, handleManualFetch] = useDiaryData();
	const handleSnackbarChange = useSnackbarText();
	const [sortableTodoes, setSortableTodoes] = useState([]);

	const currentDateData = diary.data.filter(e => e.date === diary.selectedDate)[0];

	const eventItems = currentDateData ? currentDateData.events : [];
	const birthdateItems = currentDateData ? currentDateData.birthdates : [];
	const todoItems = currentDateData ? currentDateData.todoes : emptyList;
	const todoSyncKey = `${diary.selectedDate}:${todoItems.map(todo => todo.todoID).join(',')}`;

	useEffect(() => {
		setSortableTodoes(todoItems);
	}, [todoSyncKey]);

	const handleTodoSort = useCallback((sortedTodoes) => {
		setSortableTodoes(sortedTodoes);
	}, []);

	const handleTodoSortEnd = useCallback(async () => {
		const todoIDs = sortableTodoes.map(todo => todo.todoID);

		if(!todoIDs.length) return;

		const { success, data } = await todoes.reorderTodoes({
			date: diary.selectedDate,
			todoIDs,
		});

		if(!success) {
			handleSnackbarChange({ text: data.message || 'Failed to sort todo list', variant: 'error' });
			handleManualFetch();
			return;
		}

		handleManualFetch();
	}, [sortableTodoes, diary.selectedDate, handleManualFetch, handleSnackbarChange]);

	return (
		<div className={classes.root}>
			<Typography className={classes.date}>
				{moment(diary.selectedDate).format(dateDisplayFormat)}
			</Typography>
			<div className={classes.listWrapper}>
				{!Boolean(currentDateData) && !diary.loading && (
					<Typography className={classes.noFound}>No event found</Typography>
				)}

				{birthdateItems.map((e, i) => (
					<BirthdateItem key={i} details={e} />
				))}

				{eventItems.map((e, i) => (
					<EventItem key={i} details={e} />
				))}

				<ReactSortable
					list={sortableTodoes}
					setList={handleTodoSort}
					onEnd={handleTodoSortEnd}
					handle=".todo-sort-handle"
					animation={180}
				>
					{sortableTodoes.map((e, i) => (
						<TodoItem key={e.todoID || i} details={e} sortableEnabled />
					))}
				</ReactSortable>
			</div>
			<pre>{/*JSON.stringify(currentDateData, null, 4)*/}</pre>
		</div>
	);
}

export default ItemListSection;
